import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export type TrackExceptionProperties = NonNullable<
  Parameters<ApplicationInsights['trackException']>[1]
>;

let appInsights: ApplicationInsights | undefined;

const toError = (error: unknown): Error => {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === 'string') {
    return new Error(error);
  }

  return new Error('Unknown client error');
};

export const initiateApplicationInsights = (connectionString: string) => {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
    },
  });

  appInsights.loadAppInsights();
  appInsights.trackPageView();
};

export const trackCustomException = (
  error: unknown,
  properties: TrackExceptionProperties = {}
) => {
  appInsights?.trackException(
    {
      exception: toError(error),
    },
    properties
  );
};
